/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../membershipManager.module.ts" />
/// <reference path="membershipManager.base.section.ts" />
/// <reference path="../../../components/models/meevo.dtos.d.ts" />
/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipManager {
    "use strict";

    import ClientMembershipBillStatusEnum = Meevo.Model.ClientMembershipBillStatusEnum;
    import AccruedServiceSharingEnum = Meevo.Model.AccruedServiceSharingEnum;

    interface IMembershipService {
        dateCreated: Date,
        displayName: string,
        isAvailable: boolean,
        transferFee: number,
        clientServiceId: string,
        clientPackageId: string,
        serviceId: string,
        selectedToTransfer: boolean,
    }
    interface ITransferFilter {
        isAvailable: boolean
    }

    /**
     * Section
     */
    export class TransferSection extends MembershipBaseSection {
        private today: Date;
        public transferButtonName: string;
        public transferFilterPlaceholder: string;
        public filteredData: boolean = true;
        public showOnlyAvailable: boolean = true;
        public membership: Meevo.Model.Membership;
        public client: Meevo.Model.ClientListItem;
        public accruedServicesList: any[];
        public servicesListTotalRemaining: number = 0;
        public isHasBillsSuspended: boolean = false;
        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public selectedClients: any[];
        public transferExpiredMembershipDeny: boolean;
        public transferExpiredMembershipHide: boolean;
        public transferFilter: ITransferFilter;
        public filterOptions: any[];
        public availablePackageExist: boolean = false;
        public allowOffsiteTransfers: boolean = false;
        public allowOffsiteTransferSecurityKey: Model.SecurityItem;
        public isAllowOffsiteTransferSecurityKeyHide: boolean = false;

        constructor(protected params: IMembershipManagerSectionParams) {
            super(params);

            this.transferButtonName = params.$translate.instant('LABEL_CHANGE_HOME_LOCATION');
            this.transferFilterPlaceholder = params.$translate.instant('LABEL_SHOW_ALL');

            this.today = new Date();
            this.today.setHours(0, 0, 0, 0);

            this.params.securityChecker.checkSecurityKey(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICESOFEXPIREDMEMBERSHIP)
                .then((securityCode: Meevo.Model.SecurityAccessEnum) => {
                    this.transferExpiredMembershipDeny = securityCode === Meevo.Model.SecurityAccessEnum.Deny && this.params['context'].isInActiveState == false;
                    this.transferExpiredMembershipHide = securityCode === Meevo.Model.SecurityAccessEnum.Hide && this.params['context'].isInActiveState == false;
                });
            this.params.$rootScope.$on(Meevo.Components.Common.Messages.CHECK_SECURITY_KEY_AFTER_ELEVATION, () => {
                this.transferExpiredMembershipDeny = false;
            });

            this.filterOptions = [
                {label: 'LABEL_SHOW_ALL', value: null},
                {label: 'LABEL_YES', value: true},
                {label: 'LABEL_NO', value: false}
            ];
        }

        public validateCanEdit() {
            let allowOffsiteTransferSecurityKey = this.allowOffsiteTransferSecurityKey ? this.allowOffsiteTransferSecurityKey.securityAccess !== Meevo.Model.SecurityAccessEnum.Hide : true;

            return ((this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.Cancelled ||
                (this.model.clientMembershipStatusEnum === Model.ClientMembershipStatusEnum.Cancelled &&
                (this.model.accruedServiceExpireDate >= this.today || this.availablePackageExist))) &&
                ((this.model.homeLocationId !== this.identityService.locationId &&
                (this.allowOffsiteTransfers || !this.allowOffsiteTransfers && allowOffsiteTransferSecurityKey)) ||
                (this.model.homeLocationId === this.identityService.locationId))
            )
        }

        // Function from base section in Membership Manger
        public loadDependentData(): ng.IPromise<any> {
            this.getClientMembershipBills();

            this.selectedClients = (this.model && this.model.clientId) ? [{ id: this.model.clientId }] : [];

            return this.params.$q.all([this.getBusinessSettings(), this.getClientMembershipServices(), this.getMembership()]).then(() => {
                _.each(this.accruedServicesList, (el: any) => {
                    el.transferFee = this.membership.sharingFee;
                    if (el.isAvailable) {
                        this.availablePackageExist = true;
                    }
                });
            });
        }

        // Get membership for sharingFee value
        private getMembership(): ng.IPromise<any> {
            return this.dataService.getItem('membership', this.model.membershipId)
                .then((data: any) => {
                    this.membership = data;
                    if (!Model.Guard.isSomething(this.membership.sharingFee, false)) {
                        this.membership.sharingFee = null;
                    }
                    if (this.membership.accruedServiceSharingEnum === Meevo.Model.AccruedServiceSharingEnum.NoSharing) {
                        this.membership.sharingFee = null;
                    }
                });
        }

        // Get List Services for Transfer
        private getClientMembershipServices(): ng.IPromise<any> {
            return this.params.dataService.getClientMembershipServices(new Guid(this.model.id), true)
                .then((data: Array<IMembershipService>) => {
                    this.filteredData = false;
                    if(this.accruedServicesList && this.accruedServicesList.length){
                        this.showOnlyAvailable = false;
                        let mergedServices = _.map(data,(item: any)=>{
                            let accruedService = _.find(this.accruedServicesList, (itm: any) => {
                                return itm.clientServiceId === item.clientServiceId;
                            });
                            if(accruedService){
                                item.selectedToTransfer = item.isAvailable ? accruedService.selectedToTransfer : false;
                            }
                            item.showItem = true;
                            if(this.transferFilter !== undefined) {
                                if (this.transferFilter.isAvailable == false) {
                                    if(item.isAvailable) {
                                        item.showItem = false;
                                    }
                                }
                                if (this.transferFilter.isAvailable == true) {
                                    if(!item.isAvailable) {
                                        item.showItem = false;
                                    }
                                }
                            }
                            return item;
                        });
                        this.accruedServicesList = _.sortBy(mergedServices, 'dateCreated');
                    }else{
                        this.accruedServicesList = _.sortBy(data, 'dateCreated');
                    }
                    if(this.transferFilter !== undefined) {
                        if (this.transferFilter.isAvailable == false) {
                            this.servicesListTotalRemaining = _.filter(data, (el) => el.isAvailable === false).length;
                        }
                        if (this.transferFilter.isAvailable == true) {
                            this.servicesListTotalRemaining = _.filter(data, (el) => el.isAvailable === true).length;
                        }
                        if (this.transferFilter.isAvailable == null) {
                            this.servicesListTotalRemaining = data.length;
                        }
                    } else {
                        this.servicesListTotalRemaining = _.filter(data, (el) => el.isAvailable === false).length;
                    }
                });
        }

        // Get List Services for Transfer
        private getClientMembershipBills(): void {
            
            let bills = _.filter(this.model['originMembershipBills'], (item: any) => {
                return item.clientMembershipBillStatus === ClientMembershipBillStatusEnum.Suspended
                    || item.clientMembershipBillStatus === ClientMembershipBillStatusEnum.Pending
            });

            if (bills.length) {
                this.isHasBillsSuspended = true;
            }
        }

        public get canTransferToLocation(): boolean {
            return this.model &&
                (
                    this.model.homeLocationId === this.identityService.locationId
                    && this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.Cancelled
                    && this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.CancelBeforeEnrollment
                    && this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.Expired
                );
        }

        public validateTransferToLocation(): boolean {
            if (this.params['context'].isReadonly && !this.canTransferToLocation) {
                return false;
            }
            if (this.model.clientMembershipIndicatorStatus === Meevo.Model.ClientMembershipIndicatorStatusEnum.InCancellation) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_INCANCELLATION');
                return false;
            } else if (this.model.clientMembershipIndicatorStatus === Meevo.Model.ClientMembershipIndicatorStatusEnum.Suspended) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_SUSPENDED');
                return false;
            } else if (this.model.clientMembershipIndicatorStatus === Model.ClientMembershipIndicatorStatusEnum.Frozen) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_FROZEN');
                return false;
            } else if (this.model.clientMembershipIndicatorStatus === Model.ClientMembershipIndicatorStatusEnum.Expired) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_EXPIRED');
                return false;
            } else if (this.model.clientMembershipIndicatorStatus === Model.ClientMembershipIndicatorStatusEnum.Error) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_ERROR');
                return false;
            } else if (this.isHasBillsSuspended) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT_BILL_PENDING');
                return false;
            } else if (this.model.isTransferToAnotherLocationNotAllowed) {
                this.params.modalService.message('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_MEMBERSHIP_SETTINGS_DONT_ALLOW_TRANSFERS');
                return false;
            }
            
            return true;
        }

        public isDisabledTransferLocation(): boolean {
            return !this.validateTransferToLocation();
        }

        public transferToLocation(params) {
            let requestCount = {
                criteria: {
                    includeActive: true,
                    includeInactive: true,
                    includeDeleted: true,
                    coBusinessTypeId: null,
                    coFilterByLocationId: params.location.id,
                    coSearchResultFilter: 0,
                    coSearchType: 1,
                    location: params.location,
                    businessType: null,
                    maintenanceMode: true,
                    filter: this.model.membershipDisplayName
                }
            };

            this.dataService.getCount('membership', requestCount).then((results: any) => {
                if (results > 0) {
                    this.params.$rootScope.$broadcast(Meevo.Components.Common.Messages.HIDE_MODAL_WINDOW);
                    this.model.homeLocationId = params.location.id;
                    this.model.homeLocationName = params.location.storeName;
                    this.model.homeLocationNumber = params.location.storeNumber;
                } else {
                    this.params.modalService.alert('MESSAGE_MEMBERSHIPMANAGER_TRANSFER_CANNOT', Meevo.Components.Modal.ModalTranslationModes.Translate);
                }
            });
        }

        public get totalTransferFee() {
            let sum = 0;
            _.each(this.accruedServicesList, (el) => {
                if (el["selectedToTransfer"] === true) {
                    sum += el.transferFee;
                }
            });

            return sum;
        }

        public doTransferServices(suppressWarnings: boolean = false) {
            this.transferServices(suppressWarnings);
        }

        private transferServices(suppressWarnings: boolean): void {
            let transferRequest = {
                id: this.model.id,
                clientId: this.client.id,
                suppressWarnings: suppressWarnings,
                services: _.filter(this.accruedServicesList, (el) => el["selectedToTransfer"] === true)
            };
            let sourceClient = {
                id: this.model.clientId,
                firstName: this.model.clientFirstName,
                lastName: this.model.clientLastName,
                clientMembershipId: this.model.id
            };

            let transferRequestParams = { skipInterceptor: true };

            this.params['context'].setMode(Model.MaintenanceFormState.Readonly);

            this.params.dataService.customMethodData(`/api/Membership/Client/${this.model.id}/Service`, 'POST', transferRequest, transferRequestParams)
                .then((response) => {
                    if (!response || !response.data || response.data.length < 1) {
                        return;
                    }

                    this.client = undefined;

                    this.params.$rootScope.$broadcast("gotoState",
                        {
                            stateName: "register",
                            stateParams: {
                                action: Meevo.Components.Common.Messages.PACKAGE_TRANSFER,
                                section: "SECTION_MEMBERSHIPMANAGER_TRANSFER",
                                transferredServices: response.data,
                                sourceClient: sourceClient,
                                isPackageTransferOverride: suppressWarnings,
                            }
                        });
                })
                .catch((response) => {
                    if (this.params.securityChecker.hasSecurity(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICEOVERRIDE)) {
                        this.params.modalService.confirm(response.data.responseStatus.errors[0].message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                            this.doTransferServices(true);
                        })
                            .catch((res) => {
                                if (!res) {
                                    this.client = undefined;

                                    this.accruedServicesList.forEach((item) => {
                                        item.selectedToTransfer = false;
                                    });
                                }
                            });
                    } else {
                        this.params.securityChecker.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICEOVERRIDE).then((item: Model.SecurityItem) => {
                            if (item.securityAccess == Model.SecurityAccessEnum.Deny && item.canElevate) {
                                this.params.modalService.confirm(response.data.responseStatus.errors[0].message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate).then(() => {
                                    let defer = this.params.$q.defer();
                                    defer.promise.then(() => {
                                        this.doTransferServices(true);
                                    });
                                    this.params.$rootScope.$broadcast(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, item.key.replace(/:/gi, '_'), item.displayName, this.params.identityService.current().userName, item.securityKeyPath);
                                })
                            }
                            else {
                                this.params.modalService.warning(response.data.responseStatus.errors[0].message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate);
                            }
                        });
                    }
                });
        }

        public showTransferServices(): boolean {
            return this.membership
                && !(this.membership.accruedServiceSharingEnum === AccruedServiceSharingEnum.NoSharing)
                && this.accruedServicesList
                && this.accruedServicesList.length > 0;
        }

        canTransfer(): boolean {
            return this.client
                && this.membership
                && this.accruedServicesList.filter(item => item.selectedToTransfer === true).length > 0;
        }

        isRestrictedFromTransfer(serviceId: string): boolean{
            if (this.membership && this.membership.excludedServicesFromTransfer.length > 0) {
                return (this.membership.excludedServicesFromTransfer.some((element) => element === serviceId));
            } else {
                return false;
            }
        }


        // Transfer Filter
        public applyFilter(): ng.IPromise<any> {
            const request = this.transferFilter;
            const url = `/api/Membership/Client/${this.model.id}/Service/List`;
            this.params.busyService.start();
            this.showOnlyAvailable = false;
            return this.params.dataService.customMethodData(url, 'POST', request)
                .then((data) => {
                    this.filteredData = true;
                    const request = data.data;
                    if(this.accruedServicesList && this.accruedServicesList.length){
                        let mergedServices = _.map(request,(item: any)=>{
                            let accruedService = _.find(this.accruedServicesList, (itm: any) => {
                                return itm.clientServiceId === item.clientServiceId;
                            });
                            if(accruedService){
                                item.selectedToTransfer = item.isAvailable ? accruedService.selectedToTransfer : false;
                            }
                            return item;
                        });
                        this.accruedServicesList = _.sortBy(mergedServices, 'dateCreated');
                        _.each(this.accruedServicesList, (el: any) => {
                            el.transferFee = this.membership.sharingFee;
                        });
                    }else{
                        this.accruedServicesList = _.sortBy(request, 'dateCreated');
                    }
                    this.servicesListTotalRemaining = request.length;
                })
                .finally(() => {
                    this.params.busyService.stop();
                });
        }

        // Get business info
        public getBusinessSettings(): ng.IPromise<any> {
            return this.dataService.customMethodData("api/tenant/businessInfo/settings", "get", null).then((res) => {
                this.allowOffsiteTransfers = res.data.membershipSettings.allowOffsiteMembershipAccruedServiceTransfers;

                this.params.securityChecker.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_OFFSITE_TRANSFERSERVICEOVERRIDE)
                    .then((securityItem: Model.SecurityItem) => {
                        this.allowOffsiteTransferSecurityKey = securityItem;

                        if (!this.allowOffsiteTransfers && this.allowOffsiteTransferSecurityKey.securityAccess === Meevo.Model.SecurityAccessEnum.Hide) {
                            this.isAllowOffsiteTransferSecurityKeyHide = true;
                        }
                    });
            });
        }

        public getSecurityKeyForTransfer(): any {
            this.params.securityChecker.checkSecurityItem(this.securityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_ACTION_TRANSFERSERVICE)
                .then((securityItem: Model.SecurityItem) => {
                    if (this.model.homeLocationId !== this.identityService.locationId && !this.allowOffsiteTransfers) {
                        return this.allowOffsiteTransferSecurityKey.key;
                    } else {
                        return securityItem.key;
                    }
                });
        }
    }
}
